import React from 'react';
import Navbar from './global-components/navbar-v2';
import ErrorPage from './section-components/error';
import Footer from './global-components/footer';

const Home_V1 = () => {
    return <div>
        <Navbar />
        <ErrorPage />
        <Footer />
    </div>
}

export default Home_V1

